// @flow
export type Bottle = {
  name: string,
  img?: string,
  types: Array<{ type: string, box: number, price: number }>,
  html: string
};

export type Order = { [name: string]: { [type: string]: number } };

const CATALOG: Array<Bottle> = [
  {
    name: "Brut vignoble",
    img: "brut_vignoble.jpg",
    types: [
      { type: "Bouteille", box: 6, price: 2000 },
      { type: "Magnum", box: 3, price: 4200 }
    ],
    html: `Le Brut Vignoble est un champagne issu d’une sélection de parcelles choisies pour la qualité de leurs raisins. L’élevage sur lies fines des vins permet de bien mettre en valeur ses arômes.<br>
    De cette volonté de conserver toutes les caractéristiques des vendanges, nous ne filtrons pas les vins mais réalisons un léger collage qui conserve les arômes et en font un champagne de garde.<br>
    Le Brut Vignoble est ainsi composé de 45% de chardonnay, 45% de Meunier, et 10% de Pinot Noir.<br>
    Sa structure et son élégance  en font un champagne qui accompagnera aussi bien vos apéritifs que des plats raffinés.`
  },
  {
    name: "Brut vignoble blanc de noirs",
    img: "blanc-de-noirs.jpg",
    types: [
      { type: "Bouteille", box: 6, price: 2100 },
      { type: "Magnum", box: 3, price: 4400 }
    ],
    html: `Cette cuvée a été créée afin de vous faire découvrir notre cépage de prédilection le Meunier.<br>
    Le Brut Vignoble Blanc de Noirs est un champagne fin, élégant, fruité et d'une belle complexité.`
  },
  {
    name: "Brut vignoble rosé",
    img: "rose.jpg",
    types: [
      { type: "Bouteille", box: 6, price: 2200 }
    ],
    html: `Le Brut Vignoble rosé est un assemblage à part entière afin de vous offrir un champagne aux arômes de fruits.<br>
    Il est le résultat d’un assemblage de vins blancs et d’un vin rouge réalisé à partir de Meunier.<br>
    Une macération longue à basse température nous permet d’obtenir un vin rouge fin, élégant et fruité idéal pour la réalisation de cette cuvée.`
  },
  {
    name: "Millésime 2012",
    img: "millesime.jpg",
    types: [
	{ type: "Bouteille", box: 6, price: 2450 },
        { type: "Magnum", box: 3, price: 5000}
    ],
    html: `Le millésime 2012 est champagne composé uniquement de Pinots Noirs d'une maturité exceptionnelle.<br>
    Cette cuvée vieillie plus de 3 ans dans nos caves est un champagne de garde puissant et complexe.`
  },
/*  {
    name: "Millésime 2013",
    img: "glass.jpg",
    types: [{ type: "Bouteille", box: 6, price: 2300 }],
    html: `Le millésime 2013 est champagne composé uniquement de Chardonays d'une maturité exceptionnelle.<br>
    Cette cuvée vieillie plus de 3 ans dans nos caves est un champagne de garde puissant et complexe médaille d'or du Prix Plaisir Bettane+Desseauve`
  },*/
  {
    name: "Coteau Champenois « Le clos des potiers »",
    // img: "glass.jpg",
    types: [{ type: "Bouteille", box: 6, price: 1800 }],
    html: ``
  },
  {
    name: "Gallice brut",
    types: [
      { type: "Demi-Bouteille", box: 12, price: 925 },
      { type: "Bouteille", box: 6, price: 1650 },
     // { type: "Magnum", box: 3, price: 3500 }
    ],
    html: ``
  },
  /*{
    name: "Gallice rosé",
    types: [{ type: "Bouteille", box: 6, price: 1850 }],
    html: ``
  }*/
];

export const emptyOrder = () => {
  const order = {};

  CATALOG.forEach(({ name, types }) => {
    order[name] = {};
    types.forEach(({ type }) => {
      order[name][type] = 0;
    });
  });

  return order;
};

export default CATALOG;



// WEBPACK FOOTER //
// ./src/NosBouteilles/catalog.js